import { tv } from 'tailwind-variants';

export const multiStepRangeSliderRecipe = tv({
  slots: {
    root: 'relative flex flex-col items-center w-full cursor-pointer group py-2',
    track: 'relative w-full h-1 bg-brand-gray-6 rounded-full',
    progress: 'absolute h-1 bg-brand-fill-magic rounded-full left-0',
    thumb:
      'absolute w-4 h-4 -mr-[10px] bg-brand-fill-magic rounded-full shadow-md -top-1.5 focus:outline-none',
    stepsContainer: 'flex justify-between w-full mt-2 px-1',
    stepMark:
      'absolute w-0.5 h-2 bg-brand-background transform -translate-x-1/2',
    stepLabel: 'text-xs text-gray-600',
  },
  variants: {
    disabled: {
      true: {
        root: 'cursor-not-allowed opacity-60',
        thumb: 'bg-gray-400',
        progress: 'bg-gray-300',
      },
    },
  },
  defaultVariants: {
    disabled: false,
  },
});
